import { BreadcrumbSchema } from '@/app/components/SEO/StructuredData';
import type { BreadcrumbItem } from '@/lib/seo/schemas';
import { Breadcrumbs, type BreadcrumbVariant } from './Breadcrumbs';

interface PageBreadcrumbsProps {
  items: BreadcrumbItem[];
  variant?: BreadcrumbVariant;
  className?: string;
  schemaId?: string;
}

/** Visible breadcrumb nav plus matching BreadcrumbList JSON-LD for SEO and AEO. */
export function PageBreadcrumbs({
  items,
  variant = 'default',
  className = '',
  schemaId = 'breadcrumb-schema',
}: PageBreadcrumbsProps) {
  if (items.length <= 1) return null;

  return (
    <>
      <BreadcrumbSchema items={items} id={schemaId} />
      <Breadcrumbs items={items} variant={variant} className={className} />
    </>
  );
}
